import React from 'react';
import { Modal } from 'antd';
import * as Yup from 'yup';
import { FormatText, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm } from '@digital/ui';
import { putCreateUsuarioFornecedorContratoMultiplosGestoresFornecedores } from '@app/api/contrato';


const ModalCriarUsuarioFornecedor = ({ contratoId, PlanilhaDeQuantidadeId, exibirModal, setExibirModal, onUpdate}: any) => {

    const onCancel = () => {
        setExibirModal(false);
    };

    const getAllCodigoPerfil = [
        { text: "Fornecedor Gestor", value: 12 },
        { text: "Fornecedor Fiscal", value: 13 },
        { text: "Fornecedor Financeiro", value: 20 }
    ];

    const onSubmit = (values: any) => {
        putCreateUsuarioFornecedorContratoMultiplosGestoresFornecedores({
            CodigoPerfil: values.codigoPerfil,
            ContratoId: contratoId,
            PlanilhaDeQuantidadeId
        })
            .then(data => {
                if (data.valid) {
                    setExibirModal(false);
                    onUpdate()
                }
            })
    };

    return (
        <>

            <Modal
                title="Adicionar Novo Usuário Fornecedor"
                visible={exibirModal}
                onCancel={() => onCancel()}
                footer={null}
                width="780px">
                {exibirModal && (
                    <MasterDetailForm
                        key="formAdicionarNovoUsuarioFornecedor"
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            justificativa: Yup.string()
                                .required('Justificativa deve ser informado.'),
                            codigoPerfil: Yup.string()
                                .required('Selecione um perfil.'),
                        })}
                        actions={[
                            <FormSubmitButton noIcon type="primary">
                                <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>,
                        ]}>

                        <FormSelect name="codigoPerfil" label="Perfil do Usuário" span={12} options={getAllCodigoPerfil} />
                        <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} />

                    </MasterDetailForm>
                )}
            </Modal>
        </>
    );
};

export default ModalCriarUsuarioFornecedor;